var map = {
	"./rich-annex.svg": 3729,
	"./rich-bold.svg": 63928,
	"./rich-center.svg": 78110,
	"./rich-decrease.svg": 41621,
	"./rich-divider.svg": 6380,
	"./rich-font.svg": 99730,
	"./rich-increase.svg": 90221,
	"./rich-italic.svg": 87857,
	"./rich-left.svg": 59810,
	"./rich-link.svg": 46529,
	"./rich-location.svg": 66920,
	"./rich-mark.svg": 74006,
	"./rich-markdown.svg": 43694,
	"./rich-ordered.svg": 76824,
	"./rich-quote.svg": 90355,
	"./rich-right.svg": 35193,
	"./rich-size.svg": 76322,
	"./rich-strikethrough.svg": 74438,
	"./rich-sub.svg": 67553,
	"./rich-tag.svg": 33215,
	"./rich-todo.svg": 65517,
	"./rich-underline.svg": 79115,
	"./rich-unordered.svg": 54931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44897;